import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { EmploymentAccess } from '../employment-access.model';
import { EmploymentAccessDataFetcherService } from '../services/employment-access-data-fetcher.service';

@Injectable({ providedIn: 'root' })
export class MyEmploymentsAccessResolver implements Resolve<EmploymentAccess[]> {
  constructor(private employmentAccessDataFetcherService: EmploymentAccessDataFetcherService) {}

  resolve(): Observable<EmploymentAccess[]> {
    return this.employmentAccessDataFetcherService.fetchMyEmploymentsAccessData();
  }
}
